<template>
  <div class="lineItem" v-infinite-scroll="loadMore" infinite-scroll-disabled='loading' infinite-scroll-distance='10'>
    <div class="lineItem_list" v-for='(item, index) in orderData' :key="index">
      <div class="lineItem_head">
        <div>
          <span class="site_text">{{ item.site_name }}</span>
          <span class="status_text">订单完成</span>
        </div>
        <div>
          <span class="time_text">{{ item.create_time }}</span>
        </div>
      </div>
      <div class="lineItem_content">
        <div v-if="item.order_type!==3">
          <span>撬装点</span>
          <span>加油量：{{ item.num }}升</span>
        </div>
        <div v-if="item.order_type==3">
          <span>中石油</span>
          <span>总价：{{ item.total_money }}元 加油量：{{ item.num }}升</span>
        </div>
        <div>
          <span>车牌号</span>
          <span>{{ item.car_number }}</span>
        </div>
      </div>
    </div>
    <!--显示加载中-->
    <div class="loading-box" v-if="isloading">
      <mt-spinner type="snake" class="loading-more"></mt-spinner>
      <span class="loading-more-txt">加载中...</span>
    </div>
    <!-- 显示没有更多 -->
    <div class="no-more" v-show="noMone">暂无更多数据</div>
  </div>
</template>

<script>
import common from "../common";
import {InfiniteScroll, Spinner} from 'mint-ui';
import Vue from "vue";

Vue.use(InfiniteScroll);
Vue.component(Spinner.name, Spinner);
export default {
  name: 'lineItem',
  data() {
    return {
      msg: '订单详情',
      orderData: [],
      pageVal: "0",
      pageSize: "10",
      loading: false, //为true时不会触发加载更多，false可以触发
      isloading: false,//显示加载中
      noMone: false,//是否没有更多
      token: ""
    }
  },
  methods: {
    //获取列表
    getList() {
      let token = this.token;
      let querystring = require('querystring');
      this.$api.post('wx/orderList',
          querystring.stringify({
            pageSize: this.pageSize,
            pageNum: this.pageVal,
            token: token
          })
      ).then(data => {
        if (this.pageVal < data.data.pageTotal) {
          for (var i = 0; i < this.pageSize; i++) {
            this.orderData.push(data.data.data[i]);
          }
          this.loading = false;
        } else if (this.pageVal == data.data.pageTotal) {
          for (var i = 0; i < data.data.data.length; i++) {
            this.orderData.push(data.data.data[i]);
          }
          this.loading = false;
        } else {
          this.loading = true;
          this.noMone = true;
        }
        this.isloading = false;
      }).catch(err => {
        console.log(err);
      })
    },
    //分页加载更多
    loadMore() {
      this.loading = true;
      this.isloading = true;
      this.pageVal++;
      this.getList();
    },
  },
  mounted() {
    //判断cookie中是否存在token
    let ifcookietoken = document.cookie.indexOf("token=") != -1;
    if (!!JSON.parse(common.getlocalStorage("userInfo"))) {
      this.token = JSON.parse(common.getlocalStorage("userInfo")).token;
    } else if (ifcookietoken) {
      this.token = common.getCookie("token");
    } else {
      this.$router.replace({name: 'login'});
    }
  },
  beforeDestroy() {

  },
}
</script>

<style scoped>
.lineItem {
  width: 100vw;
  height: 100vh;
  background: #f5f5f5;
  overflow: scroll;
  color: #666666;
}

.lineItem .site_text {
  font-size: .5rem;
}

.lineItem .status_text {
  font-size: .5rem;
}

.lineItem .time_text {
  font-size: .4rem;
}

.lineItem_list {
  width: 100vw;
  height: 18vh;
  background: white;
  margin-bottom: 1vh;
}

.lineItem_list > div {
  width: 85vw;
  margin: 1vh auto;
  padding: 0 2vw;
  display: -webkit-flex;
  flex-direction: column;
}

.lineItem_list > .lineItem_head {
  height: 5vh;
  padding: 1.5vh 0;
  border-bottom: 1px solid #f1f1f1;
  justify-content: space-around;
}

.lineItem_head > div {
  display: -webkit-flex;
  justify-content: space-between;
}

.lineItem_content {
  height: 8vh;
  font-size: .4rem;
  justify-content: space-around;
}

.lineItem_content > div {
  width: 85vw;
  display: -webkit-flex;
  justify-content: space-between;
  align-items: center;
}

.loading-box {
  align-items: center;
  display: -webkit-flex;
  justify-content: center;
}

.no-more {
  width: 100VW;
  height: 10vh;
  text-align: center;
  line-height: 80px;
  font-size: 16px;
}
</style>
      


// WEBPACK FOOTER //
// src/components/lineItem.vue